import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { PiX } from 'react-icons/pi';
import { cn } from '@v2/design-system';

type Props = {
    open: boolean;
    onClose: () => void;
    title: string;
    description?: string;
    children: React.ReactNode;
    footer?: React.ReactNode;
    size?: 'md' | 'lg' | 'xl' | '2xl' | '5xl';
};

const sizeClass = {
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '5xl': 'max-w-5xl',
};

export default function V2Modal({ open, onClose, title, description, children, footer, size = 'lg' }: Props) {
    return (
        <Dialog open={open} onClose={onClose} className="relative z-[70]">
            <div className="fixed inset-0 bg-black/50 dark:bg-black/70" aria-hidden="true" />
            <div className="fixed inset-0 flex items-center justify-center p-4">
                <DialogPanel
                    className={cn(
                        'w-full rounded-xl shadow-xl',
                        'bg-white dark:bg-gray-900',
                        'border border-transparent dark:border-gray-700',
                        sizeClass[size],
                    )}
                >
                    {/* Cabeçalho */}
                    <div className="flex items-start justify-between border-b border-gray-100 px-5 py-4 dark:border-gray-700/60">
                        <div>
                            <DialogTitle className="text-base font-semibold text-gray-900 dark:text-gray-100">
                                {title}
                            </DialogTitle>
                            {description && (
                                <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">{description}</p>
                            )}
                        </div>
                        <button
                            type="button"
                            onClick={onClose}
                            className="rounded p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-800 dark:hover:text-gray-300"
                        >
                            <PiX className="h-5 w-5" />
                        </button>
                    </div>

                    {/* Corpo */}
                    <div className="max-h-[70vh] overflow-y-auto px-5 py-4 text-gray-700 dark:text-gray-300">
                        {children}
                    </div>

                    {/* Rodapé */}
                    {footer ? (
                        <div className="flex justify-end gap-2 border-t border-gray-100 px-5 py-3 dark:border-gray-700/60">
                            {footer}
                        </div>
                    ) : null}
                </DialogPanel>
            </div>
        </Dialog>
    );
}
